import {FC, Card, PropsWithChildren} from 'external/react'
import Icon from 'external/fortawesome'
import ButtonBack from 'components/ButtonBack'
import BasicLayout from './BasicLayout'
import useAccounting from 'context/accounting-context/hook'

const formatAmount = (amount: number) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'usd' }).format(amount / 100);

const formatDate = (unixTimestamp: number) =>
  new Date(unixTimestamp * 1000).toLocaleDateString('es-PR', { year: 'numeric', month: 'long', day: 'numeric' });

const statusLabels: Record<string, { label: string; className: string }> = {
  paid:       { label: 'Pagado',      className: 'bg-success' },
  failed:     { label: 'Fallido',     className: 'bg-danger'  },
  pending:    { label: 'Pendiente',   className: 'bg-warning' },
  in_transit: { label: 'En tránsito', className: 'bg-info'    },
  canceled:   { label: 'Cancelado',   className: 'bg-secondary'},
};
const defaultStatus = {className: 'bg-secondary', label: 'Desconocido'}

const ClientContainer: FC<PropsWithChildren> = props => {
  const { children } = props;
  const { payout } = useAccounting();

  const p = payout?.data?.payout?.properties;
  const status = p ? (statusLabels[p.status] ?? { label: p.status, className: 'bg-secondary' }) : defaultStatus;

  return (
    <BasicLayout>
      <Card.Header className='card--header d-flex align-items-center'>
        <div className='d-flex flex-column justify-content-center'>
          <ButtonBack path='/accounting/payouts' />
        </div>
        <div className='ms-2 d-flex align-items-center' style={{ fontSize: '31px' }}>
          <Icon name='faDollar' />
        </div>
        <div className='ms-2 d-flex flex-column justify-content-center'>
          {p ? (
            <>
              <div className='d-flex align-items-center gap-2'>
                <span className='fw-semibold'>{formatAmount(p.amount)} USD</span>
                <span className={`badge ${status.className}`}>{status.label}</span>
              </div>
              <small className='text-muted'>Completado el {formatDate(p.arrival_date)}</small>
            </>
          ) : (
            <span className='fw-semibold'>...</span>
          )}
        </div>
      </Card.Header>
      {children}
    </BasicLayout>
  );
};

export default ClientContainer;